import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import ServiceIntegrationPage from '@src/pages/Services/Integration';

export const Route = createLazyFileRoute('/services/integration')({
  component: ServiceIntegrationPageWithLayout,
});

function ServiceIntegrationPageWithLayout() {
  return (
    <DefaultLayout>
      <ServiceIntegrationPage />
    </DefaultLayout>
  );
}
